<template>
  <div class="brands-horizontal-filter ">
    <v-btn
      v-if="showAllBtn"
      class="mb-2 brands-horizontal-filter_item brands-horizontal-filter_item__first"
      large
      :color="getBtnColor(0)"
      @click.prevent="setValue(0)"
    >
      Все
    </v-btn>

    <v-btn
      v-for="item in items"
      :key="`brand-${item.id}`"
      :color="getBtnColor(item.id)"
      class="mb-2 brands-horizontal-filter_item"
      large
      @click.prevent="setValue(item.id)"
    >
      {{ item.name }}
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'BrandsHorizontalFilter',
    props: {
      showAllBtn: {
        type: Boolean,
        default: false,
      },
      value: {
        type: String,
        default: null,
      },
      items: {
        type: Array,
        default: () => ([]),
      },
    },
    methods: {
      getBtnColor (id) {
        return id === this.value ? 'primary' : '#fff'
      },
      setValue (id) {
        this.$emit('input', id)
      },
    },
  }
</script>

<style scoped lang="less">
.brands-horizontal-filter {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;

  &_item {
    margin-right: 10px;
    /*box-shadow: 0 2px 2px #00000029; */
    //border:  1px solid rgba(0, 0, 0, 0.2) !important;
    //box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.2);
    box-shadow: 0 3px 6px #00000029;
    border-radius: 0 10px 0 10px;

    @media (max-width: 1500px) {
      padding: 0 15px !important;
      min-width: 80px !important;
    }

    &__first {

    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
